var MiscueText = {

  MISCUE_SEARCH_PATTERN: /(\<Miscue.*?\<\/Miscue\>)/g,

  _getAssessmentContent(parsedData, miscueCreateCallback){
    return parsedData.map((item) => {
      if (React.isValidElement(item)) {
        return item;
      }

      if (item && typeof item === "object") {
        return miscueCreateCallback(item)
      }

      return null;
    });
  },

  _parseAssessmentContent(content, miscues){
    var itemContent = reactStringReplace(content, this.MISCUE_SEARCH_PATTERN, this._getMiscueElementData.bind(null, miscues));

    return itemContent.map((itemContent, index) => {
      return typeof itemContent === "object"
        ? itemContent
        : <span dangerouslySetInnerHTML={{__html: itemContent}}
                key={'inner-html-'+index}/>
    });
  },

  _getMiscueElementData(miscues, data, index){
    var $htmlElement = $($.parseHTML(data)[0]),
      miscueId = $htmlElement.data('id'),
      content = $htmlElement.text(),
      miscueData;

    if (!miscueId) return null;

    miscueData = miscues.find((item) => {
      return item.id == miscueId
    });
    miscueData.content = content.trim();
    return miscueData;
  }

};


module.exports = MiscueText;
